import { Library } from 'lucide-react'
import { SiteLayout } from '../components/ui/site-chrome'
import { TrustPage } from '../components/ui/trust-page'

export default function ResourcesPage() {
  return (
    <SiteLayout
      current="/resources"
      title="Resources for Founders and AI Teams | Zadro"
      description="Resources and mental models for founders, AI teams, and companies evaluating fractional CTO support, AI adoption, and product innovation."
    >
      <TrustPage
        Icon={Library}
        visual="resources"
        eyebrow="Resources"
        heroTitle="Mental models for founders building in the AI era."
        heroCopy="This page acts as a trust hub for the ideas behind the work: circuit audits, AI governance, canonical contextual agents, founder technical leadership, and product innovation."
        proof={[
          'Written for founders and operators who need clear language, not jargon.',
          'Connects AI and engineering decisions to business outcomes.',
          'Designed to help buyers prepare for a better diagnostic conversation.',
        ]}
        cards={[
          {
            title: 'Circuit Audit Checklist',
            copy: 'Where are projects slowing down? Which handoffs fail? What decisions keep repeating? What systems create rework?',
          },
          {
            title: 'AI Readiness Questions',
            copy: 'What data is available? Who owns review? How will quality be measured? What workflow changes if AI works?',
          },
          {
            title: 'Founder CTO Primer',
            copy: 'How to scope software, evaluate vendors, manage engineers, challenge estimates, and learn enough to lead with confidence.',
          },
        ]}
        sections={[
          {
            kicker: 'Before The Call',
            title: 'Come prepared with one constraint.',
            copy: 'The best 18-minute diagnostic starts with one concrete problem. It does not need to be perfectly framed. It just needs to be real.',
            items: [
              'A roadmap that feels stuck',
              'An AI idea that needs production shape',
              'A team or vendor relationship that is underperforming',
              'A product or platform bottleneck that may be leaking revenue',
            ],
          },
          {
            kicker: 'Future Content',
            title: 'This becomes the education layer of the site.',
            copy: 'As the site grows, this section can become essays, guides, workshop recaps, frameworks, and product build-in-public updates.',
            items: [
              'Canonical contextual agents guide',
              'AI workshop agendas and city events',
              'Product Innovator build logs',
              'Founder technical leadership templates',
            ],
          },
        ]}
      />
    </SiteLayout>
  )
}
